// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Guidelines_wrapper__DsdnV","innerWrapper":"Guidelines_innerWrapper__3eZtx"};